(function () {
    'use strict';
    angular.module('components.conversationDialog', []);
})();